import { useState } from 'react';
// import ReactPixel from 'react-facebook-pixel';
import { Field, withTypes } from 'react-final-form';
// import ReactGA from 'react-ga';
import { GB, TH } from 'country-flag-icons/react/3x2';
import toast from 'react-hot-toast';
import 'react-phone-number-input/style.css';
import { useNavigate } from 'react-router-dom';
import { Button } from 'reactstrap';
import Icon from '../../../assets/icons/Icon';
import PasswordChecklist from '../../../components/PasswordChecklist';
import CustomCheckBox from '../../../components/form/CustomCheckBox';
import CustomInputField from '../../../components/form/CustomInputField';
import CustomSelect from '../../../components/form/CustomSelect';
import PhoneNumberField from '../../../components/form/PhoneNumberField';
import Alert from '../../../components/notification/Alert';
import { useDict, useLanguageUpdate } from '../../../contexts/LanguageContext';
import PrivacyNoticeEngPDF from '../../../documents/privacy_notice_EN.pdf';
import PrivacyNoticeThaiPDF from '../../../documents/privacy_notice_TH.pdf';
import TermsOfServiceEngPDF from '../../../documents/terms_of_service_EN.pdf';
import TermsOfServiceThaiPDF from '../../../documents/terms_of_service_TH.pdf';
import ROUTE_NAME from '../../../routes/RouteName';
import { postSignUp } from '../src/registrationApis';

// can enable when we add this functionality in the future

// ReactGA.initialize(ENV.GOOGLE);
// ReactGA.pageview(window.location.pathname + window.location.search);
// ReactPixel.init(ENV.FACEBOOK);
// ReactPixel.pageView();

const SignUpForm = (props) => {
    const { isRegistrationLoading } = props;

    const dict = useDict();
    const toggleLanguage = useLanguageUpdate();

    const navigate = useNavigate();

    const [showPassword, setShowPassword] = useState(false);
    const [showRePassword, setShowRePassword] = useState(false);
    const [isErrorICEmail, setIsErrorICEmail] = useState(false);

    const locale = [
        { value: 'th', label: <><TH title="Thai" className="flag-icon" /> {dict.thai}</> },
        { value: 'en', label: <><GB title="English" className="flag-icon" /> {dict.english}</> },
    ];

    const openPDFPreview = (pdfFile) => {
        window.open(pdfFile, '_blank');
    };

    const { Form } = withTypes();

    const signUpValidate = (values) => {
        const errors = {};
        if (!values.first_name) {
            errors.first_name = dict.firstNameEmpty;
        }
        if (!values.last_name) {
            errors.last_name = dict.lastNameEmpty;
        }
        if (!values.identification_no) {
            errors.identification_no = dict.icPassportEmpty;
        } else if (
            !/^\d{13}$|^[A-Z0-9]{6,12}$/.test(values.identification_no)

        ) {
            // checks if identification_no matches ic or passport no format
            errors.identification_no = dict.passportInvalid;
        }
        if (!values.email) {
            errors.email = dict.emailEmpty;
        } else if (
            !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)
        ) {
            errors.email = dict.emailInvalid;
        }
        if (!values.password) {
            errors.password = dict.passwordEmpty;
        } else if (
            !/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*,.()\-+_={}[\]{};'\\:"|\\/<>?~`])(?=.{8})/.test(
                values.password
            )
        ) {
            errors.password = dict.passwordInvalid;
        }
        if (!values.password_confirmation) {
            errors.password_confirmation = dict.rePasswordEmpty;
        } else if (values.password_confirmation !== values.password) {
            errors.password_confirmation = dict.passwordsNotMatch;
        }
        if (!values.phone_no) {
            errors.phone_no = dict.phoneNoEmpty;
        }
        if (!values.locale) {
            errors.locale = dict.languageEmpty;
        }
        if (!values.tnc_agreement) {
            errors.tnc_agreement = dict.agreeToProceed;
        }
        return errors;
    };

    const handleSubmitResponse = (response) => {
        localStorage.setItem('registration_id', response.id);
        localStorage.setItem('email', response.email);
        navigate(ROUTE_NAME.REGISTRATION_DETAILS);
    };

    const handleSubmitError = (error) => {
        if (error.response.status === 422) {
            setIsErrorICEmail(true);
        } else {
            toast.error(
                error.response.data.message ?? error.response.data.error,
                {
                    duration: 5000,
                }
            );
        }
    };

    const handleSubmit = (values) => {
        postSignUp(values, handleSubmitResponse, handleSubmitError);
    };

    return (
        <Form
            initialValues={{
                locale: localStorage.getItem('language') === 'en' ? 'en' : 'th',
                first_name: '',
                last_name: '',
                identification_no: '',
                email: '',
                password: '',
                password_confirmation: '',
                phone_no: '',
                tnc_agreement: false,
            }}
            validate={signUpValidate}
            onSubmit={(values) => {
                handleSubmit(values);
            }}
        >
            {({ handleSubmit, values }) => (
                <form
                    className="form"
                    onSubmit={handleSubmit}
                    style={{ marginTop: '30px' }}
                >
                    {isRegistrationLoading && (
                        <div className="panel__refresh">
                            <Icon icon="Loading" />
                        </div>
                    )}
                    {isErrorICEmail && (
                        <div className="form__form-group margin-top-negative-10">
                            <Alert
                                color="danger"
                                className="alert--colored"
                                icon
                            >
                                <p>
                                    {dict.registrationFailedText}
                                    <a href="mailto:thaisupport@capbay.com">
                                        {' '}
                                        thaisupport@capbay.com
                                    </a>
                                </p>
                            </Alert>
                        </div>
                    )}
                    <div
                        className="form__form-group"
                        style={{ marginTop: '5px' }}
                    >
                        <div className="form__form-group">
                            <div className="form__form-group-field">
                                <Field name="locale">
                                    {({ input, meta }) => (
                                        <CustomSelect
                                            input={input}
                                            meta={meta}
                                            options={locale}
                                            placeholder={dict.language + ' *'}
                                            onChange={(value) => {
                                                if (value) {
                                                    toggleLanguage(value?.value);
                                                }
                                            }}
                                            isClearable
                                            data-cy="signUp__locale"
                                            height="40px"
                                            border="1px solid #dddddd"
                                        />
                                    )}
                                </Field>
                            </div>
                        </div>
                        <div className="form__form-group-field">
                            <Field name="first_name">
                                {({ input, meta }) => (
                                    <CustomInputField
                                        input={input}
                                        meta={meta}
                                        type="text"
                                        placeholder={dict.firstName + ' *'}
                                        data-cy="signUp__first_name"
                                    />
                                )}
                            </Field>
                        </div>
                    </div>
                    <div className="form__form-group margin-top-negative-10">
                        <div className="form__form-group-field">
                            <Field name="last_name">
                                {({ input, meta }) => (
                                    <CustomInputField
                                        input={input}
                                        meta={meta}
                                        type="text"
                                        placeholder={dict.lastName + ' *'}
                                        data-cy="signUp__last_name"
                                    />
                                )}
                            </Field>
                        </div>
                    </div>
                    <div className="form__form-group margin-top-negative-10">
                        <div className="form__form-group-field" data-private>
                            <Field name="identification_no">
                                {({ input, meta }) => (
                                    <CustomInputField
                                        input={input}
                                        meta={meta}
                                        type="text"
                                        placeholder={dict.icPassport + ' *'}
                                        data-cy="signUp__identification_no"
                                    />
                                )}
                            </Field>
                        </div>
                    </div>
                    <div className="form__form-group margin-top-negative-10">
                        <div className="form__form-group-field">
                            <Field name="email">
                                {({ input, meta }) => (
                                    <CustomInputField
                                        input={input}
                                        meta={meta}
                                        type="email"
                                        placeholder={dict.email + ' *'}
                                        data-cy="signUp__email"
                                    />
                                )}
                            </Field>
                        </div>
                    </div>
                    <div className="form__form-group margin-top-negative-10">
                        <div className="form__form-group-field">
                            <Field name="password">
                                {({ input, meta }) => (
                                    <CustomInputField
                                        input={input}
                                        meta={meta}
                                        type={
                                            showPassword ? 'text' : 'password'
                                        }
                                        placeholder={dict.password + ' *'}
                                        data-cy="signUp__password"
                                    />
                                )}
                            </Field>
                            <span
                                className={`form__form-group-button ${showPassword && 'active'
                                    } form__form-group-button--show-password`}
                                onClick={() => setShowPassword(!showPassword)}
                                role="button"
                                aria-hidden
                                tabIndex={0}
                            >
                                <Icon
                                    icon={showPassword ? 'Eye' : 'EyeSlash'}
                                    data-cy="icon__eye"
                                />
                            </span>
                        </div>
                    </div>
                    <div className="form__form-group margin-top-negative-10">
                        <div className="form__form-group-field">
                            <Field name="password_confirmation">
                                {({ input, meta }) => (
                                    <CustomInputField
                                        input={input}
                                        meta={meta}
                                        type={
                                            showRePassword ? 'text' : 'password'
                                        }
                                        placeholder={dict.rePassword + ' *'}
                                        data-cy="signUp__rePassword"
                                    />
                                )}
                            </Field>
                            <span
                                className={`form__form-group-button ${showRePassword && 'active'
                                    } form__form-group-button--show-password`}
                                onClick={() =>
                                    setShowRePassword(!showRePassword)
                                }
                                role="button"
                                tabIndex={0}
                                aria-hidden
                            >
                                <Icon
                                    icon={showRePassword ? 'Eye' : 'EyeSlash'}
                                />
                            </span>
                        </div>
                    </div>
                    <div className="form__form-group margin-top-negative-10">
                        <PasswordChecklist
                            password={values.password || ''}
                            rePassword={values.password_confirmation || ''}
                        />
                    </div>
                    <div className="form__form-group margin-top-negative-10">
                        <Field name="phone_no">
                            {({ input, meta }) => (
                                <PhoneNumberField
                                    input={input}
                                    meta={meta}
                                    placeholder="Enter phone number *"
                                    data-cy="signUp__phone"
                                />
                            )}
                        </Field>
                    </div>
                    <div
                        className="form__form-group mb-0"
                        style={{ marginTop: '-5px' }}
                    >
                        <div
                            className="form__form-group-field"
                            style={{ fontSize: '12px' }}
                        >
                            <Field name="tnc_agreement" type="checkbox">
                                {({ input, meta }) => (
                                    <CustomCheckBox
                                        input={input}
                                        meta={meta}
                                        defaultChecked={false}
                                        label={dict.bySigningUpText}
                                        data-cy="signUp__agreeCheckbox"
                                        pdfLinks={
                                            [
                                                { link: values.locale === 'th' ? TermsOfServiceThaiPDF : TermsOfServiceEngPDF, name: dict.termsOfService },
                                                { link: values.locale === 'th' ? PrivacyNoticeThaiPDF : PrivacyNoticeEngPDF, name: dict.privacyNotice }
                                            ]
                                        }
                                        openPDFPreview={openPDFPreview}
                                    />
                                )}
                            </Field>
                        </div>
                    </div>
                    <div
                        className="account__btns"
                        style={{ marginLeft: '0px', paddingRight: '10px' }}
                    >
                        <Button
                            color="primary"
                            type="button"
                            className="btn btn-outline-primary account__btn btn-register-cancel rounded"
                            onClick={() => navigate('/')}
                            disabled={isRegistrationLoading}
                            data-cy="signUp__cancelBtn"
                        >
                            {dict.cancel}
                        </Button>
                        <Button
                            color="primary"
                            className="btn account__btn rounded"
                            type="submit"
                            style={{ margin: '10px 0 20px 10px' }}
                            data-cy="signUp__submitBtn"
                            disabled={isRegistrationLoading}
                        >
                            {dict.submit}
                        </Button>{' '}
                    </div>
                    <div className="account__or_divide">
                        <div style={{ fontSize: '11px', paddingTop: '20px' }}>
                            {dict.regulatedByText}
                        </div>
                    </div>
                </form>
            )}
        </Form>
    );
};

export default SignUpForm;
